import React from 'react';
import PropTypes from 'prop-types';
// Styles
import { Card } from './Skeleton.styles';

const SkeletonCards = ({ count = 10 }) =>
  Array.from({ length: count }, (_, i) => (
    <Card key={i} aria-hidden='true'>
      <div className='poster' />
      <div className='line' />
      <div className='line short' />
    </Card>
  ));

SkeletonCards.propTypes = {
  count: PropTypes.number
};

export default SkeletonCards;
